import { FieldArray, Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import styles from "./addDemand.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container } from "../../../components/Container/Containers";
import IMAGES from "../../../assets/images/images";
import { BackButton, Submit } from "../../../components/button/buttons";
import DiameterFields from "../template/addDemandTemplate/formFieldsTemplates/DiameterFields";
import SigtranFields from "../template/addDemandTemplate/formFieldsTemplates/SigtranFields";
import DnsFields from "../template/addDemandTemplate/formFieldsTemplates/DnsFields";
import { formSchema } from "../template/addDemandTemplate/validation/addDemandschema";
import TransportFields from "../template/addDemandTemplate/formFieldsTemplates/TransportFields";
import { SelectField } from "../template/addDemandTemplate/controllers/addDemandcontrollers";
import { buildRegionCountryOptions, filterRowForSubmit, stages } from "../template/addDemandTemplate/demandHelper";
import DestinationOpeningFields from "../template/addDemandTemplate/formFieldsTemplates/destinationopeningFields";
import { USER_TYPE } from "../../../utils/constants/userConstants";
import { buildProgressFromStates, getLocationDetails, sortByLabelAsc } from "../../../utils/arrayUtils";
import { Action, Resource } from "../../../casl/constants";
import CAN from '../../../casl/can';
import { ALLOWED_IPX_LIVE_SERVICES, AMEND_SERVICE, DIAMETER, DNS, GRX, OTHER_SERVICES, SIGTRAN, TRANSPORT, UPDATE_VOLTE, VOLTE } from "../../../utils/constants/serviceConstants";
import Shimmer from "../../../components/shimmer/Shimmer";
import MultiStageProgress from "../../../components/multistageProgress/MultiStageProgress";
import HttpFields from "../template/addDemandTemplate/formFieldsTemplates/httpFields";


const AmmendServiceDetail = ({ data, city, country, region }) => {
    return (
      <div className={styles.topSection}>
        <div className={styles.topSectionDiv}>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>VLAN ID</div>
            <div className={styles.requestorvalue}>{data?.vlan}</div>
          </div>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Router City</div>
            <div className={styles.servcevalue}>{city}</div>
          </div>
        </div>
        <div className={styles.topSectionDiv}>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Router Name</div>
            <div className={styles.requestorvalue}>{data?.pe_ref}</div>
          </div>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Allocated Capacity (Mbps)</div>
            <div className={styles.servcevalue}>{data?.logical_capacity_mbps}</div>
          </div>
        </div>
        <div className={styles.topSectionDiv}>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Region</div>
            <div className={styles.requestorvalue}>{region}</div>
          </div>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Country</div>
            <div className={styles.servcevalue}>{country}</div>
          </div>
        </div>
      </div>
    );
  }


export default function AddDemand(props) {

    const [isSubmit, setIsSubmit] = useState(false);
    const [collapse, setCollapse] = useState({});
    const navigate = useNavigate();
    const [countryDropdown, setCountryDropdown] = useState({});
    const [regionDropdown, setRegionDropdown] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState("");
    const [isNewRoamingPartner, setNewRoamingPartner] = useState(false);
    const [selectedOrganization, setSelectedOrganization] = useState({});
    const [demandServicesOptions,setDemandServicesOptions]=useState([]);
    const [countryOptions,setCountryOptions]=useState([]);
    // const [volteCountries,setVolteCountries]=useState([]);
    const serviceDetail = props.servicesDetail;
    const [workflowStages, setWorkflowStages] = useState([])
    let { mode,demandId } = useParams();
    const RequestorTadig = props.myRights?.userType===USER_TYPE.CUSTOMER? props?.myRights?.cpName : "";
    const RequestorOrganisationName = props.myRights?.userType===USER_TYPE.CUSTOMER? props?.myRights?.customerUserMetaInfo?.customerName : "";

    const getRegionByRouter = (pe_ref) => {
        if (pe_ref) {
          const obj =  getLocationDetails(props.pops,pe_ref)
          return obj?.region.value;
        }
    }
    
    const getLocationByRouter = (pe_ref) => {
        const obj =  getLocationDetails(props.pops,pe_ref)
        return obj?.city;
    }
    const getCountryByRouter = (pe_ref) => {
        const obj =  getLocationDetails(props.pops,pe_ref)
        return obj?.country;
    }

    const getRegionLabel=(location)=>{
        let Label = regionDropdown.find(({ value }) => value?.toLowerCase() === location?.toLowerCase())?.label;
        return Label
    }

    const getAmendServiceObject=(id)=>{
        return props.liveServicesData.find(item => item.id === id)
    }

    
    let defaultFormObj = {
        service: "",
        location: "",
        dns_number: "",
        checkBox: [],
        top_destinations: "",
        avg_monthly_msu_volumes: "",
        avg_monthly_dtr_volumes: "",
        category:[],
        avg_mon_trans_volume:"",
        fiveG_Core:"",
        fiveG_SA_domestically:"",
        hosted_Sepp_at_vodafone:"",
        allocated_capacity: "",
        files:[],
        comment: "",
        country: "" ,
        isExistingRoamingPartner: "",
        roamingPartnerTadigId: "",
        requestorCountry: "",
        requestorTadig: "",
        requestorOrganisationName: "",
        connectivityServiceType: "",
        direction: "",
        roamingPartnerName: "",
        additional_info:{}
    }
    let initalFormObj={}

    if(mode==UPDATE_VOLTE){
         initalFormObj = {
            ...defaultFormObj,
            service:  VOLTE,
            country: serviceDetail?.services?.serviceCountry?.label ,
            files: serviceDetail?.services?.files ?? [],
            isExistingRoamingPartner: serviceDetail?.services?.service_option?.isExistingRoamingPartner,
            roamingPartnerTadigId: serviceDetail?.services?.service_option?.roamingPartnerTadigId,
            requestorCountry: serviceDetail?.services?.service_option?.requestorCountry ,
            requestorTadig: serviceDetail?.services?.service_option?.requestorTadig,
            requestorOrganisationName: serviceDetail?.services?.service_option?.requestorOrganisationName ,
            connectivityServiceType: serviceDetail?.services?.service_option?.connectivityServiceType,
            direction: serviceDetail?.services?.service_option?.direction,
            roamingPartnerName: serviceDetail?.services?.service_option?.roamingPartnerName,
        }
    }else if(mode==AMEND_SERVICE){
        const originalServiceData =  getAmendServiceObject(demandId) //props.amendServiceInitialValue
        initalFormObj={
            ...defaultFormObj,
            service: originalServiceData?.id,
            location:getRegionByRouter(originalServiceData?.pe_ref),
            country:getCountryByRouter(originalServiceData?.pe_ref),
            additional_info:originalServiceData
        }
    }else{
        initalFormObj={
            ...defaultFormObj,
            service: mode==VOLTE ? VOLTE: "",
            requestorTadig: mode==VOLTE ? RequestorTadig: "",
            requestorOrganisationName: mode==VOLTE ? RequestorOrganisationName : "",

        }
    }
    
    const initalValuesObj={
        organization: mode === UPDATE_VOLTE ? serviceDetail?.tadigId : props.myRights?.cpName,
        formObj:initalFormObj
    }

    const filterDataByLocation = (liveServiceData) => { //demandServicesOptions

        const filtered = liveServiceData?.filter(item => {
            const service = item?.ipx_service?.trim().toLowerCase();
            const city = getLocationByRouter(item?.pe_ref)
            return ALLOWED_IPX_LIVE_SERVICES.includes(service) && city && city != 'undefined' && city != undefined
          });

        const newDropDown = filtered?.map(item => {
            const city = getLocationByRouter(item?.pe_ref)
            if(ALLOWED_IPX_LIVE_SERVICES.includes(item?.ipx_service?.trim().toLowerCase()) && city && city != 'undefined' && city != undefined){
                return {
                    label: `${item?.ipx_service?.toUpperCase()} - ${city }`,
                    value: item.id
                }
            }
            }
        );
        return newDropDown ?? [];
    }

    const regionCountryOptions = useMemo(() => {
        return buildRegionCountryOptions(props.locations);
    }, [props.locations]);

    const back = () => {
        navigate(-1);
        // navigate("/connectivity/demands")
    }

    const addService = (push) => {
        push(defaultFormObj)
    }

    const volteCountries = props?.countries?.data?.map((country) => ({
            value: country.name,
            label: country.name,
        }));

    useEffect(() => {
        setRegionDropdown(regionCountryOptions.regionList);
        setCountryDropdown(regionCountryOptions.countryMap);
    }, [regionCountryOptions]);

   
    useEffect(() => {
        if(mode==AMEND_SERVICE){
            const demandsOptions= filterDataByLocation(props.liveServicesData);
            setDemandServicesOptions(demandsOptions ?? [])
        }else if(mode==OTHER_SERVICES){
            const other_servies=props.services?.filter(item => {
                return item.value != VOLTE
            })
            setDemandServicesOptions(other_servies ?? [])
        }else if(mode==VOLTE || mode == UPDATE_VOLTE){
            const other_servies=props.services?.filter(item => {
                return item.value == VOLTE
            })
            setDemandServicesOptions(other_servies ?? [])
        }
    }, [props.liveServicesData,props.services])

    useEffect(()=>{
        setCountryOptions(countryDropdown[selectedRegion] ?? [])
    },[selectedRegion])

    useEffect(() => {
        props.getLocations();
        props.getServices();
        props.getCustomers();

        // const convertedCountries = props?.countries?.data?.map((country) => ({
        //     value: country.name,
        //     label: country.name,
        // }));
        // setVolteCountries(convertedCountries)

        if (CAN(Action.LIST_COUNTRIES, Resource.DEMANDS)) {
            props.getContriesList();
        }
        if (CAN(Action.LIST_ROAMING_PARTNERS, Resource.DEMANDS)) {
            props.getRoamingPartnerList();
        }

        if(mode==UPDATE_VOLTE){
            props.getServiceDetail(demandId);
        }else if(mode==AMEND_SERVICE){
            let searchKey = "";
            let statusFilter = ""
            const orgName = "";
            const service = "";
            let cp_name = props.myRights?.cpName;
            props.getLiveServices(cp_name, searchKey,'',orgName,service,statusFilter) 
        }

        const formattedStages = buildProgressFromStates(stages || [], "DEMAND_CREATED", null ,{}) // actionStatus is null and demand close data is blank
        setWorkflowStages(formattedStages);

    }, [mode,demandId])

    return (
        <Container>
           <div className={styles.progressWrapper}>
            <div className={styles.arrow}>
                <img src={IMAGES.backarrow} alt="back" className={styles.backbtn} onClick={back}/>
            </div>
            {mode===UPDATE_VOLTE || mode===VOLTE?<></>: 
            <div className={styles.multiprogress}>
                <MultiStageProgress workflowStages={workflowStages} currentState={"DEMAND_CREATED"} demandCreated={true}/>
            </div>}
           </div>
            <div className={styles.parentcontainer}>
                <div className={styles.header}>
                    <div className={styles.headerwrapper}>
                        <div className={styles.headertxt}>{mode === AMEND_SERVICE? "Amend Existing Service Demand Form":mode === UPDATE_VOLTE ?"Update Demand":"New Demand Form"}</div>
                        <div className={styles.headersubtxt}>{mode===UPDATE_VOLTE || mode===VOLTE?<></>:"Step 1 - 6 Demand"}</div>
                    </div>
                </div>
                {props.isLoading ? <div className={styles.shimmerWrapper}><Shimmer/> </div> :
                <div className={styles.container}>
                    <Formik
                        initialValues={{
                            organization:initalValuesObj.organization,
                            info: [initalValuesObj.formObj]
                        }}
                        enableReinitialize={true}
                        validationSchema={formSchema}
                        validateOnMount 
                        onSubmit={async (values, { resetForm }) => {
                            setIsSubmit(true);
                            try {
                                const cleanedInfo = (values?.info ?? []).map(row => {
                                    switch (row?.service?.split('-')[0]){
                                        case "DNS":
                                          return {
                                            service: row?.service?.split('-')[0],
                                            serviceRegion : {'label': getRegionLabel(row.location),'value':row.location},
                                            serviceCountry: {'label': row?.country,'value':row?.country},
                                            service_option:{
                                              dns_number:row?.dns_number,
                                            },
                                            comment: row?.comment,
                                            files: row?.files,
                                            additional_info:{...row?.additional_info,router_location:getLocationByRouter(row?.additional_info?.pe_ref)} 
                                          };
                                           case "HTTP2":
                                          return {
                                            service: row?.service?.split('-')[0],
                                            serviceRegion : {'label': getRegionLabel(row.location),'value':row.location},
                                            serviceCountry: {'label': row?.country,'value':row?.country},
                                            service_option:{
                                                category:row?.category,
                                                avg_mon_trans_volume: row?.avg_mon_trans_volume,
                                                fiveG_Core: row?.fiveG_Core,
                                                fiveG_SA_domestically: row?.fiveG_SA_domestically,
                                                hosted_Sepp_at_vodafone: row?.hosted_Sepp_at_vodafone,
                                            },
                                            comment: row?.comment,
                                            files: row?.files,
                                            additional_info:{...row?.additional_info,router_location:getLocationByRouter(row?.additional_info?.pe_ref)} 
                                          };
                                        case "SIGTRAN":
                                          return {
                                            service: row?.service?.split('-')[0],
                                            serviceRegion : {'label': getRegionLabel(row?.location),'value':row?.location},
                                            serviceCountry: {'label': row?.country,'value':row?.country},
                                            service_option:{
                                              type:row?.checkBox,
                                              avg_monthly_msu_volumes:row?.avg_monthly_msu_volumes,
                                              top_destinations : row?.top_destinations,
                                            },
                                            comment: row?.comment,
                                            files: row?.files,
                                            additional_info:{...row?.additional_info,router_location:getLocationByRouter(row?.additional_info?.pe_ref)} 
                                          };
                                        case "DIAMETER":
                                          return {
                                            service: row?.service?.split('-')[0],
                                            serviceRegion : {'label': getRegionLabel(row?.location),'value':row?.location},
                                            serviceCountry: {'label': row?.country,'value':row?.country},
                                            service_option:{
                                              avg_monthly_dtr_volumes: row?.avg_monthly_dtr_volumes,
                                            },
                                            comment: row?.comment,
                                            files: row?.files,
                                            additional_info:{...row?.additional_info,router_location:getLocationByRouter(row?.additional_info?.pe_ref)} 
                                          };
                                        case "TRANSPORT" :
                                        case "GRX" :    
                                          return {
                                            service: "TRANSPORT",
                                            serviceRegion : {'label': getRegionLabel(row?.location),'value':row?.location},
                                            serviceCountry: {'label': row?.country,'value':row?.country},
                                            service_option:{
                                              allocated_capacity: row?.allocated_capacity,
                                            },
                                            comment: row?.comment,
                                            files: row?.files,
                                            additional_info:{...row?.additional_info,router_location:getLocationByRouter(row?.additional_info?.pe_ref)} 
                                          };
                                        case "VOLTE":
                                          return {
                                            service_option:{
                                             isExistingRoamingPartner : isNewRoamingPartner? false :true,
                                              roamingPartnerName: row?.roamingPartnerName,
                                              roamingPartnerTadigId: row?.roamingPartnerTadigId,
                                              connectivityServiceType : row?.connectivityServiceType,
                                              direction: row?.direction,
                                              requestorTadig: row?.requestorTadig?.toUpperCase(),
                                              requestorOrganisationName: row?.requestorOrganisationName,
                                              requestorCountry: row?.requestorCountry,
                                            },
                                            service: row?.service?.split('-')[0],
                                            serviceCountry: {'label': row?.country,'value':row?.country},
                                            files: row.files,
                                            additional_info:{...row?.additional_info,router_location:getLocationByRouter(row?.additional_info?.pe_ref)} 
                                          };
                                        default:
                                          return { service: row?.service };
                                      }
                                });
                                console.log("Submitting payload (cleaned info preview):", cleanedInfo);
                                let obj = {};

                                if (mode === UPDATE_VOLTE) {
                                    obj.uniqueCustomerRefId = serviceDetail?.uniqueCustomerRefId;
                                    obj.demandNumberSF = serviceDetail?.demandNumberSF;
                                    obj.requestId = serviceDetail?.requestId;
                                    obj.organisationName=serviceDetail?.organisationName;
                                    obj.tadigId=serviceDetail?.tadigId?.trim()
                                } else if (props.myRights.userType===USER_TYPE.CUSTOMER) {
                                    obj.uniqueCustomerRefId = props.myRights?.customerUserMetaInfo?.uniqueCustomerRefId;
                                    obj.organisationName=props.myRights?.customerUserMetaInfo?.customerName;
                                    obj.tadigId=values?.organization?.trim()
                                } else {
                                    obj.uniqueCustomerRefId = selectedOrganization?.uniqueCustomerRefId;
                                    obj.organisationName=selectedOrganization?.displayName;
                                    obj.tadigId=selectedOrganization?.cpName?.trim()
                                }

                                if(mode == OTHER_SERVICES || mode == AMEND_SERVICE){
                                    obj.serviceType=OTHER_SERVICES
                                }else if(mode == VOLTE || mode == UPDATE_VOLTE){
                                    obj.serviceType=VOLTE
                                }
                                obj.services=cleanedInfo
                                
                                // if (mode != UPDATE_VOLTE) {
                                //     obj.status = "received";
                                // }

                                if(mode != UPDATE_VOLTE){
                                    const result = await props.submitRequest(obj);
                                    if (result?.status) {
                                        // back()
                                        navigate("/connectivity/demands")
                                        setIsSubmit(false);
                                        resetForm();
                                        props.openAlertPopup({
                                            message: `A new demand with ID: ${result?.res?.data?.requestId} has been created`,
                                            image: IMAGES.success
                                        });
                                        props.getServicesList?.();
                                    } else if (result?.code === 500) {
                                        const errormsg = (
                                            <div>
                                                Service temporarily unavailable. Please try again later.
                                                <div style={{ marginTop: "10px" }} />
                                            </div>
                                        );
                                        props.showErrorPopup?.(
                                            { errorHeader: "Service Unavailable" },
                                            { errorMessage: errormsg }
                                        );
                                    setIsSubmit(false);
                                    } else {
                                        setIsSubmit(false);
                                        const error_msg =
                                            result?.error ??
                                            "An error occurred while processing your request. Please try again later.";
                                        props.openAlertPopup?.({
                                            message: error_msg,
                                            image: IMAGES.error
                                        });
                                    }
                                }else{
                                    const result = await props.SubmitUpdateRequst(obj,demandId)
                                    if (result?.status) {
                                        // back()
                                        navigate("/connectivity/demands")
                                        setIsSubmit(false);
                                        resetForm();
                                        props.openAlertPopup({
                                            message: `A demand with ID: ${result?.res?.data?.requestId} has been Updated`,
                                            image: IMAGES.success
                                        });
                                        props.getServicesList?.();
                                    } else if (result?.code === 500) {
                                        const errormsg = (
                                            <div>
                                                Service temporarily unavailable. Please try again later.
                                                <div style={{ marginTop: "10px" }} />
                                            </div>
                                        );
                                        props.showErrorPopup?.(
                                            { errorHeader: "Service Unavailable" },
                                            { errorMessage: errormsg }
                                        );
                                        setIsSubmit(false);
                                    } else {
                                        setIsSubmit(false);
                                        const error_msg =
                                            result?.error ??
                                            "An error occurred while processing your request. Please try again later.";
                                        props.openAlertPopup?.({
                                            message: error_msg,
                                            image: IMAGES.error
                                        });
                                    }
                                }
                            } catch (error) {
                                console.error("Submit error:", error);
                                setIsSubmit(false);
                                props.openAlertPopup?.({
                                    message: "An error occurred while processing your request. Please try again later.",
                                    image: IMAGES.error
                                });
                            } finally {
                                setIsSubmit(false);
                            }
                        }}
                    >
                        {({ isValid, dirty }) => (
                            <Form>
                                <FieldArray name="info">
                                    {({ push, remove, form }) => {
                                        const { values, setFieldValue, setFieldTouched, validateField } = form;
                                        return (
                                            <>
                                                <div className={styles.subheader}>
                                                    <div className={styles.servicetext}>Service Required</div>
                                                    {mode != UPDATE_VOLTE && mode != VOLTE && <div className={styles.addservice} onClick={() => addService(push)}>+ Add Service</div>}
                                                </div>
                                                {
                                                    props.myRights?.userType === USER_TYPE.INTERNAL &&
                                                    <SelectField
                                                        title={"TADIG Code"}
                                                        name={`organization`}
                                                        options={sortByLabelAsc(props.organizations?.map((item) => ({ value: item?.cpName, label: item?.cpName }))) || []}
                                                        customStyles={{ width: "100%" }}
                                                        onChange={(value) => {
                                                            let selectedOrg = props?.organizations.find(item => item?.cpName === value);
                                                            setSelectedOrganization(selectedOrg)
                                                            setFieldValue(`info.${0}.requestorTadig`, selectedOrg?.cpName);
                                                            setFieldValue(`info.${0}.requestorOrganisationName`, selectedOrg?.displayName);
                                                            setFieldTouched(`info.${0}.requestorTadig`, true);
                                                            setTimeout(() => {
                                                                validateField(`info.${0}.requestorTadig`);
                                                            }, 0);
                                                        }}
                                                        isDisabled={mode == UPDATE_VOLTE}
                                                    />
                                                }
                                                {values.info.map((row, i) => (
                                                    <div key={i} >
                                                        <div className={styles.serviceWrapper} >
                                                            <div className={styles.btnwrapper}>
                                                                <div className={styles.serviceformcount}>Service {i + 1}</div>
                                                                <div className={styles.deletewrapper}>
                                                                    {values.info.length > 1 &&
                                                                        <img onClick={() => values.info.length > 1 && remove(i)}
                                                                            className={styles.btnremove} src={IMAGES.remove} alt="deleteIcon"
                                                                        />
                                                                    }
                                                                    { mode == OTHER_SERVICES ?
                                                                         <img onClick={() => setCollapse((prev) => ({ ...prev, [i]: !prev[i] }))}
                                                                            className={`${styles.btnremove} ${!collapse[i] && styles.rotatearrow}`} src={IMAGES.downchevron} alt="closeIcon"
                                                                             />
                                                                    :<></>
                                                                    }
                                                                </div>
                                                            </div>
                                                            {!collapse[i] &&
                                                                <div className={styles.formwrapper}>
                                                                    <div className="flex-item">
                                                                        <SelectField
                                                                            title={mode == AMEND_SERVICE ?"Search service you want to amend":"Service"}
                                                                            name={`info.${i}.service`}
                                                                            placeholder="-- Select --"
                                                                            options={sortByLabelAsc(demandServicesOptions)}
                                                                            onChange={(value) => {
                                                                                if(mode==AMEND_SERVICE){
                                                                                    const result = getAmendServiceObject(value);
                                                                                    setFieldValue(`info.${i}.location`, getRegionByRouter(result?.pe_ref));
                                                                                    setSelectedRegion(getRegionByRouter(result?.pe_ref), setFieldValue)
                                                                                    setFieldValue(`info.${i}.country`, getCountryByRouter(result?.pe_ref));
                                                                                    setFieldValue(`info.${i}.additional_info`, result);
                                                                                }
                                                                            }}
                                                                            isDisabled={(values.info?.[i]?.service ?? "").trim().toUpperCase() === "VOLTE"}
                                                                            customStyles={{ width: "100%" }}
                                                                        />
                                                                    </div>
                                                                    {
                                                                        ((mode==AMEND_SERVICE) && row?.service && (row?.service?.split('-')[0] !== "undefined") && (props.myRights?.userType !== USER_TYPE.INTERNAL)) ?
                                                                            <AmmendServiceDetail data={row?.additional_info} city={getLocationByRouter(row?.additional_info?.pe_ref)} country={row?.country} region={getRegionLabel(row?.location)}/> :
                                                                            <></>
                                                                    }
                                                                    {(row?.service && row?.service?.split('-')[0]!== "VOLTE") && mode!=AMEND_SERVICE && (
                                                                        <>
                                                                            <SelectField
                                                                                title={"Vodafone Connectivity PoP Region"}
                                                                                name={`info.${i}.location`}
                                                                                options={regionDropdown}
                                                                                onChange={(value) => {
                                                                                    setFieldValue(`info.${i}.country`, '');
                                                                                    setSelectedRegion(value, setFieldValue)
                                                                                }}
                                                                                customStyles={{ width: "100%" }}
                                                                            />
                                                                            <SelectField
                                                                                title={"Vodafone Connectivity PoP Country"}
                                                                                name={`info.${i}.country`}
                                                                                options={countryOptions}
                                                                                // isDisabled={!selectedRegion}
                                                                                onChange={(opt) => ''}
                                                                                customStyles={{ width: "100%" }}
                                                                            />
                                                                        </>
                                                                    )}
                                                                    { (row?.service === "HTTP2" || row?.service?.split('-')[0] === "HTTP2") && <HttpFields index={i} />}
                                                                    { (row?.service === "DNS" || row?.service?.split('-')[0] === "DNS") && <DnsFields index={i} />}
                                                                    { (row?.service === "SIGTRAN" || row?.service?.split('-')[0] === "SIGTRAN") && <SigtranFields index={i} />}
                                                                    { (row?.service === "DIAMETER" || row?.service?.split('-')[0] === "DIAMETER") && <DiameterFields index={i} />}
                                                                    { (row?.service === "TRANSPORT" || row?.service?.split('-')[0] === "GRX") && <TransportFields index={i} />}
                                                                    {row?.service === "VOLTE" && <DestinationOpeningFields index={i}
                                                                        convertedCountries={volteCountries} roamingPartnerName={props.roamingPartnerName}
                                                                        isNewRoamingPartner={isNewRoamingPartner} setNewRoamingPartner={setNewRoamingPartner}
                                                                        serviceDetail={serviceDetail} mode={mode}
                                                                    />}
                                                                </div>
                                                            }
                                                        </div>

                                                    </div>
                                                ))}
                                            </>
                                        )
                                    }}
                                </FieldArray>
                                <div className={styles.buttonContainer}>
                                    <BackButton className={styles.backButton}
                                        style={styles.submit}
                                        title={"Back"}
                                        disabled = {isSubmit}
                                        closePopup={back}
                                    />
                                    <Submit
                                        style={styles.submit}
                                        type="submit"
                                        title={"Submit"}
                                        isSubmitting={isSubmit}
                                        disabled={!isValid || !dirty}
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>}
            </div>
        </Container >
    );
}
